export function ExploreModeToggle({ modes, activeMode, onModeChange }) {
  const modeKeys = Object.keys(modes);

  return (
    <div className="inline-flex w-full sm:w-auto bg-gray-100 rounded-full p-1 mb-6">
      {modeKeys.map((key) => (
        <button
          key={key}
          type="button"
          onClick={() => onModeChange(key)}
          className={`flex-1 sm:flex-none px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            activeMode === key
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          {modes[key].label}
        </button>
      ))}
    </div>
  );
}
